export default "__VITE_ASSET__CemveZLA__"